import clamp from "../utils/clamp";
export var calculateSpeed = function (from, to) {
    var range = to - from;
    var count = range >= 1 ? 1 : 0;
    var power = calculatePower(range);
    if (range <= 0.12) {
        return {
            speed: 100,
            increment: 0.01,
        };
    }
    if (range < 10) {
        return {
            speed: 100,
            increment: 0.12,
        };
    }
    while (range / 10 >= 1) {
        range /= 10;
        ++count;
    }
    return {
        speed: 1 / Math.pow(10, count - 3),
        increment: to > from ? Math.pow(10, power) : -1,
    };
};
var clampPower = clamp(0, 4);
export var calculatePower = function (range) {
    if (!range || range < 0) {
        return 0;
    }
    var rangeStr = "" + range;
    var dotIndex = rangeStr.indexOf(".");
    return clampPower(dotIndex > -1 ? rangeStr.substring(0, dotIndex).length - 3 : rangeStr.length - 3);
};
export var startTicker = function (from, to, onTick, onEnd) {
    if (from === to) {
        onTick(to);
        if (onEnd) {
            onEnd();
        }
        return function () {
        };
    }
    var _a = calculateSpeed(from, to), speed = _a.speed, increment = _a.increment;
    var clear = function () { return clearInterval(id); };
    var current = from;
    var tick = function () {
        current += increment;
        if (current < to) {
            return onTick(current);
        }
        clear();
        onTick(to);
        if (onEnd) {
            onEnd();
        }
    };
    var id = setInterval(tick, Math.floor(speed));
    return clear;
};
export var startConstantTicker = function (from, to, time, onTick, onEnd) {
    var _a;
    if (from === to) {
        onTick(to);
        if (onEnd) {
            onEnd();
        }
        return function () {
        };
    }
    var clear = function () { return clearInterval(id); };
    var current = from;
    //adaptive ticker. it change tick time from 12 to 9 fps with step less than 1fps to find increment step
    // which will not have 5 an 0 numbers on increment for very smooth visual animation
    // or only without 5 number on increment for smooth animation ( if very smooth increment not found)
    var trimZeroSymbols = function (value, trimRight) {
        //move 2 fraction digits to int value and round value;
        var checkValueInt = Math.floor(value * 100);
        if (trimRight) {
            //string value with trim "0" from left and right
            return checkValueInt.toString().replace(/0+$/g, "");
        }
        return checkValueInt.toString();
    };
    var isIncrementVerySmooth = function (value) { return !trimZeroSymbols(value, false).match(/[05]/g); };
    var isIncrementSmooth = function (value) { return !trimZeroSymbols(value, true).match(/5/g); };
    var increment;
    var smoothIncrement;
    var verySmoothIncrement;
    var minTickTime = 84;
    var maxTickTime = 110;
    var tickTime = Math.min(time, minTickTime);
    do {
        tickTime++;
        increment = ((to - from) / time) * tickTime;
        if (isIncrementVerySmooth(increment)) {
            verySmoothIncrement = increment;
        }
    } while (tickTime <= maxTickTime && !verySmoothIncrement);
    if (!verySmoothIncrement) {
        //run search again from reset tick time because verySmoothIncrement and smoothIncrement can arrive
        // on different tick time
        tickTime = Math.min(time, minTickTime);
        do {
            tickTime++;
            increment = ((to - from) / time) * tickTime;
            if (isIncrementSmooth(increment)) {
                smoothIncrement = increment;
            }
        } while (tickTime <= maxTickTime && !smoothIncrement);
    }
    increment = (_a = verySmoothIncrement !== null && verySmoothIncrement !== void 0 ? verySmoothIncrement : smoothIncrement) !== null && _a !== void 0 ? _a : increment;
    //end of calculation adaptive ticker time and increment
    var tick = function () {
        current += increment;
        if (current < to) {
            return onTick(current);
        }
        clear();
        onTick(to);
        if (onEnd) {
            onEnd();
        }
    };
    var id = setInterval(tick, Math.floor(tickTime));
    return clear;
};
